import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { formatBevaNumber, type BevaDetail } from '@repo/field-configs';
import { pdfStyles } from '../../../shared/styles/pdf-styles';

interface PDFBevaEstimateBlockProps {
  readonly formattedBeva: string;
  readonly bevaDetail?: BevaDetail | null;
}

const cellStyle = {
  fontSize: 8,
  padding: 3,
  borderRight: '0.5pt solid #9ca3af',
  textAlign: 'center' as const,
  flexGrow: 1,
  flexShrink: 1,
};

const headerCellStyle = {
  ...cellStyle,
  fontWeight: 'bold' as const,
  backgroundColor: '#ecfdf5',
};

/**
 * PDF compact BEVA value + optional indices detail rows.
 * Width stays within the page content / section header bounds.
 */
export function PDFBevaEstimateBlock({
  formattedBeva,
  bevaDetail,
}: PDFBevaEstimateBlockProps) {
  return (
    <View style={{ alignItems: 'stretch', width: '100%', maxWidth: '100%' }}>
      <View style={[pdfStyles.bevaBox, { alignSelf: 'flex-start' }]}>
        <Text>Valeur estimée : {formattedBeva}</Text>
      </View>
      {bevaDetail ? (
        <View
          style={{
            marginTop: 4,
            border: '0.5pt solid #9ca3af',
            width: '100%',
            maxWidth: '100%',
          }}
        >
          <View style={{ flexDirection: 'row', backgroundColor: '#ecfdf5', width: '100%' }}>
            <Text style={[headerCellStyle, { flex: 0.7 }]}>Numéro</Text>
            <Text style={[headerCellStyle, { flex: 0.9 }]}>Genre</Text>
            <Text style={[headerCellStyle, { flex: 0.9 }]}>Espèce</Text>
            <Text style={[headerCellStyle, { flex: 1.2 }]}>Nom vernaculaire</Text>
            <Text style={[headerCellStyle, { flex: 0.8 }]}>Indice espèce</Text>
            <Text style={[headerCellStyle, { flex: 1.2 }]}>
              Indice esthétique et sanitaire
            </Text>
            <Text style={[headerCellStyle, { flex: 0.8 }]}>Indice situation</Text>
            <Text style={[headerCellStyle, { flex: 0.8 }]}>Indice dimension</Text>
            <Text style={[headerCellStyle, { flex: 1, borderRight: 'none' }]}>
              VALEUR B.E.V.A.
            </Text>
          </View>
          <View style={{ flexDirection: 'row', borderTop: '0.5pt solid #9ca3af', width: '100%' }}>
            <Text style={[cellStyle, { flex: 0.7 }]}>{bevaDetail.numero}</Text>
            <Text style={[cellStyle, { flex: 0.9, fontStyle: 'italic' }]}>
              {bevaDetail.genre}
            </Text>
            <Text style={[cellStyle, { flex: 0.9, fontStyle: 'italic' }]}>
              {bevaDetail.espece}
            </Text>
            <Text style={[cellStyle, { flex: 1.2 }]}>{bevaDetail.nomVernaculaire}</Text>
            <Text style={[cellStyle, { flex: 0.8 }]}>
              {formatBevaNumber(bevaDetail.varietyGrade)}
            </Text>
            <Text style={[cellStyle, { flex: 1.2 }]}>
              {formatBevaNumber(bevaDetail.aestheticHealthIndex)}
            </Text>
            <Text style={[cellStyle, { flex: 0.8 }]}>
              {formatBevaNumber(bevaDetail.locationIndex)}
            </Text>
            <Text style={[cellStyle, { flex: 0.8 }]}>
              {formatBevaNumber(bevaDetail.sizeIndex)}
            </Text>
            <Text style={[cellStyle, { flex: 1, borderRight: 'none', fontWeight: 'bold' }]}>
              {formatBevaNumber(bevaDetail.beva)} €
            </Text>
          </View>
        </View>
      ) : null}
    </View>
  );
}
